import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FileInfoTemplateDirective,
  FileSelectComponent,
  FileTemplateDirective,
} from '@progress/kendo-angular-upload';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { AttachmentProjectComponent } from './project-details/project-attachment/attachment-project.component';
import { ProjectBaseFormComponent } from './project-details/project-edit/manage-project/project-base-form/project-base-form.component';
import { ProjectCalculationFormComponent } from './project-details/project-edit/manage-project/project-calculation-form/project-calculation-form.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ManageProjectComponent } from './project-details/project-edit/manage-project/manage-project.component';
import { ProjectComponent } from './project.component';
import { ProjectDetailComponent } from './project-details/project-detail.component';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { EditProjectComponent } from './project-details/project-edit/edit-project.component';
import { ProjectMemberGridComponent } from './project-details/project-edit/manage-project/project-member-grid/project-member-grid.component';
import { ProjectTaskGridComponent } from './project-details/project-edit/manage-project/project-task-grid/project-task-grid.component';
import { ProjectCalculationFormExpenditureComponent } from './project-details/project-edit/manage-project/project-calculation-form/project-calculation-form-expenditure/project-calculation-form-expenditure.component';
import { ProjectCalculationFormBudgetComponent } from './project-details/project-edit/manage-project/project-calculation-form/project-calculation-form-budget/project-calculation-form-budget.component';
import { ProjectDetailDataStore } from './project-details/state-and-data-handling/project-detail-data.store';
import { ProjectTaskDialogComponent } from './project-details/project-edit/dialogs/project-task-dialog/project-task-dialog.component';
import { ProjectCalculationFormResetBudgetComponent } from './project-details/project-edit/manage-project/project-calculation-form/project-calculation-form-reset-budget/project-calculation-form-reset-budget.component';
import { CreateClientDialogComponent } from './project-details/project-edit/dialogs/create-client-dialog/create-client-dialog.component';
import { ExpenditureHistoryDialogComponent } from './project-details/project-edit/dialogs/expenditure-history-dialog/expenditure-history-dialog.component';
import { AfterValueChangedDirective } from '../../core/directives/after-value-changed.directive';
import { TimeBlockModule } from '../../features/calendar/components/time-block/time-block.module';
import { ProjectExpenditureChartComponent } from './project-details/project-progress/project-expenditure-chart/project-expenditure-chart.component';
import { ProjectBudgetChartComponent } from './project-details/project-progress/project-budget-chart/project-budget-chart.component';
import { ProjectProgressComponent } from './project-details/project-progress/project-progress.component';
import { ProjectSummaryAsideComponent } from './project-details/project-progress/project-summary-aside/project-summary-aside.component';
import { ProjectMemberDialogComponent } from './project-details/project-edit/dialogs/project-member-dialog/project-member-dialog.component';
import { SettingsModule } from '../settings/settings.module';
import { TimeFormatPipe } from '../../core/pipes/time-format.pipe';
import { ProjectTaskSummaryComponent } from './project-details/project-progress/project-task-summary/project-task-summary.component';
import { ProjectTeamSummaryComponent } from './project-details/project-progress/project-team-summary/project-team-summary.component';
import { ProjectExpensesComponent } from './project-details/project-expenses/project-expenses.component';
import { ShiveCurrencyPipe } from '../../core/pipes/shive-currency.pipe';
import { CostRateHistoryDialogComponent } from './project-details/project-edit/dialogs/cost-rate-history-dialog/cost-rate-history-dialog.component';
import { ProjectExpensesDialogComponent } from './project-details/project-expenses/dialog/project-expenses-dialog/project-expenses-dialog.component';
import { ProjectDataService } from './project-details/state-and-data-handling/project-data.service';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    AfterValueChangedDirective,
    TimeBlockModule,
    SettingsModule,
    TimeFormatPipe,
    ShiveCurrencyPipe,
    AdminLayoutModule,
    FileSelectComponent,
    FileTemplateDirective,
    FileInfoTemplateDirective,
  ],
  declarations: [
    ProjectProgressComponent,
    AttachmentProjectComponent,
    ProjectExpensesComponent,
    ProjectBaseFormComponent,
    ProjectCalculationFormComponent,
    ProjectListComponent,
    ManageProjectComponent,
    ProjectComponent,
    ProjectDetailComponent,
    ProjectSummaryAsideComponent,
    EditProjectComponent,
    ProjectMemberGridComponent,
    ProjectTaskGridComponent,
    ProjectCalculationFormExpenditureComponent,
    ProjectCalculationFormBudgetComponent,
    ProjectTaskDialogComponent,
    ProjectMemberDialogComponent,
    ProjectCalculationFormResetBudgetComponent,
    CreateClientDialogComponent,
    ExpenditureHistoryDialogComponent,
    CostRateHistoryDialogComponent,
    ProjectExpenditureChartComponent,
    ProjectBudgetChartComponent,
    ProjectTaskSummaryComponent,
    ProjectTeamSummaryComponent,
    ProjectExpensesDialogComponent,
  ],
  exports: [ProjectTaskGridComponent],
  providers: [ProjectDetailDataStore, ProjectDataService, ShiveCurrencyPipe],
})
export class ProjectModule {}
